export function getHubspotUtkCookie() {
  return getCookie('hubspotutk');
}

// Generally useful
function getCookie(key: string) {
  const re = new RegExp(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
  const match = document.cookie.match(re);
  return match ? match.pop() : undefined;
}
